__turbopack_context__.v({
  "caption": "ls263G_caption",
  "figure": "ls263G_figure",
  "figureCenter": "ls263G_figureCenter",
  "figureFull": "ls263G_figureFull",
  "media": "ls263G_media",
});
